export default __webpack_public_path__ + "static/media/About Us - Banner 1.ff3f1773.jpg";